import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { SdHighlightPipe } from '../../_pipes/highlight.pipe';
import { SdSanitizeHtml } from '../../_pipes/domSanitizer';

@Component({
  selector: 'sd-html',
  templateUrl: './html.component.html',
  styleUrl: './html.component.scss',
  standalone: true,
  host: { ngSkipHydration: 'true' },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SdHtmlComponent {
  tag = input<'p' | 'div' | 'span' | undefined>();
  html = input.required<string>();
  innerClass = input('');
  bold = input<string>();

  private sanitizer = inject(DomSanitizer);

  formatted = computed(() => {
    const bold = this.bold();
    const html = this.html();

    if (!html) {
      return '';
    }

    // ATTENTION: the following remove any sanitizing safety checks => it bypass the typical Angular XSS defenses !!!
    // So if the provided html text contains a <script> tag, it will be injected as is... :(
    if (typeof html === 'string') {
      return bold
        ? (new SdHighlightPipe(this.sanitizer)).transform(html, bold)
        : (new SdSanitizeHtml(this.sanitizer)).transform(html);
    } else {
      // No sanitization if html is already a SafeHtml (not a string)
      return html;
    }
  });
}
